










































































import Vue from 'vue';
import { BFormInput } from 'bootstrap-vue';

import ToggleSwitch from '@/components/toggle_switch/ToggleSwitch.vue';
import { mapActions, mapGetters } from '@/state/modules/survey_builder';

export default Vue.extend({
  name: 'Settings',
  components: {
    BFormInput,
    ToggleSwitch,
  },
  computed: {
    ...mapGetters([
      'isWeighted',
      'hasRiskThresholds',
      'midRiskThreshold',
      'isMidRiskThresholdValid',
      'highRiskThreshold',
      'isHighRiskThresholdValid',
      'minScore',
      'maxScore',
    ]),
  },
  methods: {
    ...mapActions(['setWeighted', 'setMidRiskThreshold', 'setHighRiskThreshold']),
  },
});
